const e = {
  name: "ShopperBag",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M7,8V7c0-3.9,3.1-7,7-7s7,3.1,7,7v1h7v32H0V8H7z M9,7v1h10V7c0-2.8-2.2-5-5-5S9,4.2,9,7z M7,10H2v28h24V10h-5
			v5h-2v-5H9v5H7V10z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as ShopperBag
};
